import React from "react";
import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap";

export const Dropdowns = ({ id, text, onClick, items }) => {
  return (
    <DropdownButton
      as={ButtonGroup}
      title={text}
      className="dropdownsTems"
      variant="danger"
    >
      {items
        && items.map((val, k) => {
            return (
              <Dropdown.Item value={val} id={id} onClick={onClick} key={k}>
                {val}
              </Dropdown.Item>
            );
          })
        }
    </DropdownButton>
  );
};

export const DropdownForAssign = ({ id, text, onClick, items, style }) => {
  return (
    <DropdownButton
      as={ButtonGroup}
      title={text}
      className={style}
      variant="danger"
    >
      {items
        ? items.map((val, k) => {
            return (
              <Dropdown.Item
                value={val.id}
                id={id}
                onClick={() => onClick(id, val.id)}
                key={k}
              >
                {val.email}
              </Dropdown.Item>
            );
          })
        : null}
    </DropdownButton>
  );
};
